module.exports = __webpack_public_path__ + "assets/prev-passive.cd401ea8.svg";